import {
    Component, Directive, ViewEncapsulation,
    HostBinding, OnInit, OnDestroy, Input,
    ContentChild, forwardRef, QueryList, Inject, OnChanges,
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { DeviceDetectorService } from 'ngx-device-detector';

import { Subject, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

import { EuiConfig, EUI_CONFIG_TOKEN, UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app',
    templateUrl: './eui-app.component.html',
    styleUrls: ['./_styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppComponent implements OnInit, OnDestroy, OnChanges {

    @HostBinding('class')
    get cssClasses() {
        return this.getCssClasses();
    }

    @Input() appName = ''; // TO BE DEPRECATED
    @Input() appShortName = ''; // TO BE DEPRECATED
    @Input() appSubTitle = ''; // TO BE DEPRECATED
    @Input() themeClass = '';
    @Input() isSidebarOpen = false;
    @Input() isSidebarExpandOnHover = true;
    @Input() isShrinkHeaderActive = true;
    @Input() userInfos = '';
    @Input() userSubInfos: string;
    @Input() impersonatedUserInfos: string;
    @Input()
    get isSidebarHidden() { return this._isSidebarHidden; }
    set isSidebarHidden(value) { this._isSidebarHidden = coerceBooleanProperty(value); }
    _isSidebarHidden = false;

    @ContentChild(forwardRef(() =>
        EuiAppPageWrapperDirective),
    ) customPageWrapper: QueryList<EuiAppPageWrapperDirective>;

    @ContentChild(forwardRef(() =>
        EuiAppToolbarDirective),
    ) appToolbar: QueryList<EuiAppToolbarDirective>;

    private appShellState;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        public asService: UxAppShellService,
        private deviceDetectorService: DeviceDetectorService,
        @Inject(EUI_CONFIG_TOKEN) private euiConfigToken: EuiConfig,
    ) {}

    ngOnInit() {
        this.asService.fetchCssVars();
        this.asService.initCssVars();

        const deviceInfo = this.deviceDetectorService.getDeviceInfo();

        this.asService.setState({
            ...this.asService.state,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            isSidebarOpen: this.isSidebarOpen,
            hasHeader: false,
            isSidebarHidden: this.isSidebarHidden,
            isSidebarExpandOnHover: this.isSidebarExpandOnHover,
            hasSidebar: false,
            deviceInfo: {
                info: deviceInfo,
                isChrome: deviceInfo.browser === 'Chrome',
                isIE: deviceInfo.browser === 'IE',
                isIE11: deviceInfo.browser === 'IE' && deviceInfo.browser_version === '11.0',
                isFF: deviceInfo.browser === 'Firefox',
            },
        });

        this.asService.state$
            .pipe(
                takeUntil(this.destroy$),
            )
            .subscribe((state) => {
                this.appShellState = state;
            });

        fromEvent(window, 'resize')
            .pipe(
                debounceTime(200),
                takeUntil(this.destroy$),
            )
            .subscribe(() => {
                this.asService.setState({
                    ...this.asService.state,
                    windowHeight: window.innerHeight,
                    windowWidth: window.innerWidth,
                });
            });
    }

    ngOnChanges() {
        this.asService.setState({
            ...this.asService.state,
            userInfos: this.userInfos,
            userSubInfos: this.userSubInfos,
            impersonatedUserInfos: this.impersonatedUserInfos,
        });
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    private getCssClasses() {
        return [
            'eui-app',
            this.appShellState.wrapperClasses,
        ].join(' ');
    }
}

/* tslint:disable */
@Directive({ selector: 'eui-app-page-wrapper' })
export class EuiAppPageWrapperDirective { }

@Directive({ selector: 'eui-app-toolbar' })
export class EuiAppToolbarDirective { }
/* tslint:enable */
